var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useCart } from '../context/CartContext';
import { formatEUR } from '../utils/promo';
import './CheckoutModal.css';
var CheckoutModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, language = _a.language, totalPriceEur = _a.totalPriceEur;
    var _b = useCart(), items = _b.items, clearCart = _b.clearCart, refreshPrices = _b.refreshPrices;
    var _c = useState({
        name: '',
        phone: '',
        email: '',
        address: '',
        city: '',
        postalCode: '',
        notes: '',
        deliveryMethod: 'address', // 'address' or 'office' - Default to address
        speedyOffice: '',
    }), formData = _c[0], setFormData = _c[1];
    var _d = useState({}), errors = _d[0], setErrors = _d[1];
    var _e = useState(false), showSuccessModal = _e[0], setShowSuccessModal = _e[1];
    var _f = useState(false), isSubmitting = _f[0], setIsSubmitting = _f[1];
    var modalRef = useRef(null);
    // Econt data
    var _g = useState([]), cities = _g[0], setCities = _g[1];
    var _h = useState([]), offices = _h[0], setOffices = _h[1];
    var _j = useState(''), selectedCityId = _j[0], setSelectedCityId = _j[1];
    var _k = useState(false), loadingCities = _k[0], setLoadingCities = _k[1];
    var _l = useState(false), loadingOffices = _l[0], setLoadingOffices = _l[1];
    // Focus modal when it opens and scroll to top
    useEffect(function () {
        if (isOpen && modalRef.current) {
            modalRef.current.focus();
            // Scroll to top of page when modal opens
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [isOpen]);
    // Fetch cities when office delivery method is selected
    useEffect(function () {
        if (formData.deliveryMethod === 'office' && cities.length === 0) {
            fetchCities();
        }
    }, [formData.deliveryMethod]);
    // Fetch offices when city is selected
    useEffect(function () {
        if (selectedCityId) {
            fetchOffices(selectedCityId);
        }
        else {
            setOffices([]);
        }
    }, [selectedCityId]);
    var fetchCities = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingCities(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch('/api/econt/cities')];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error('Failed to fetch cities');
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    // Econt API returns cities in data.cities array
                    if (data.cities && Array.isArray(data.cities)) {
                        setCities(data.cities);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error fetching cities:', error_1);
                    setErrors(function (prev) { return (__assign(__assign({}, prev), { econt: 'Failed to load cities' })); });
                    return [3 /*break*/, 6];
                case 5:
                    setLoadingCities(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var fetchOffices = function (cityId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, errorData, data, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoadingOffices(true);
                    setOffices([]); // Clear previous offices
                    setErrors(function (prev) { return (__assign(__assign({}, prev), { econt: '' })); }); // Clear previous errors
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    return [4 /*yield*/, fetch("/api/econt/offices?cityId=".concat(cityId))];
                case 2:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    errorData = _b.sent();
                    throw new Error(errorData.message || 'Failed to fetch offices');
                case 4: return [4 /*yield*/, response.json()];
                case 5:
                    data = _b.sent();
                    console.log("Fetched ".concat(((_a = data.offices) === null || _a === void 0 ? void 0 : _a.length) || 0, " offices for city ").concat(cityId));
                    // Econt API returns offices in data.offices array
                    if (data.offices && Array.isArray(data.offices)) {
                        if (data.offices.length === 0) {
                            setErrors(function (prev) { return (__assign(__assign({}, prev), { econt: language === 'bg'
                                    ? 'Няма налични офиси в този град'
                                    : 'No offices available in this city' })); });
                        }
                        setOffices(data.offices);
                    }
                    else {
                        throw new Error('Invalid response format');
                    }
                    return [3 /*break*/, 8];
                case 6:
                    error_2 = _b.sent();
                    console.error('Error fetching offices for cityId:', cityId, error_2);
                    setErrors(function (prev) { return (__assign(__assign({}, prev), { econt: language === 'bg'
                            ? 'Грешка при зареждане на офиси. Моля, опитайте отново.'
                            : 'Failed to load offices. Please try again.' })); });
                    setOffices([]);
                    return [3 /*break*/, 8];
                case 7:
                    setLoadingOffices(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = '', _a)));
            });
        }
    };
    var validateForm = function () {
        var newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = language === 'bg' ? 'Моля, въведете име' : 'Please enter your name';
        }
        if (!formData.phone.trim()) {
            newErrors.phone = language === 'bg' ? 'Моля, въведете телефон' : 'Please enter your phone';
        }
        else if (!/^\+?[\d\s\-()]+$/.test(formData.phone)) {
            newErrors.phone = language === 'bg' ? 'Невалиден телефонен номер' : 'Invalid phone number';
        }
        if (!formData.email.trim()) {
            newErrors.email = language === 'bg' ? 'Моля, въведете имейл' : 'Please enter your email';
        }
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = language === 'bg' ? 'Невалиден имейл адрес' : 'Invalid email address';
        }
        // Only validate address if delivery method is 'address'
        if (formData.deliveryMethod === 'address') {
            if (!formData.address.trim()) {
                newErrors.address = language === 'bg' ? 'Моля, въведете адрес' : 'Please enter your address';
            }
            if (!formData.city.trim()) {
                newErrors.city = language === 'bg' ? 'Моля, въведете град' : 'Please enter your city';
            }
        }
        // Validate ECONT office if delivery method is 'office'
        if (formData.deliveryMethod === 'office' && !formData.speedyOffice) {
            newErrors.speedyOffice = language === 'bg' ? 'Моля, изберете офис или автомат' : 'Please select an office or locker';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var orderData, response, data, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!validateForm()) {
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    orderData = {
                        name: formData.name,
                        phone: formData.phone,
                        email: formData.email,
                        address: formData.address,
                        city: formData.city,
                        deliveryMethod: formData.deliveryMethod,
                        speedyOffice: formData.speedyOffice,
                        notes: formData.notes,
                        items: items.map(function (item) { return ({ id: item.id, quantity: item.quantity }); }),
                        totalPriceEur: totalPriceEur,
                        language: language
                    };
                    return [4 /*yield*/, fetch('/api/orders', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(orderData),
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 6];
                    if (!(response.status === 409)) return [3 /*break*/, 5];
                    return [4 /*yield*/, refreshPrices()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: throw new Error(data.message || 'Failed to submit order');
                case 6:
                    // Success! Clear cart and show success modal
                    clearCart();
                    setShowSuccessModal(true);
                    // Reset form
                    setFormData({
                        name: '',
                        phone: '',
                        email: '',
                        address: '',
                        city: '',
                        postalCode: '',
                        notes: '',
                        deliveryMethod: 'address',
                        speedyOffice: '',
                    });
                    setSelectedCityId('');
                    setErrors({});
                    return [3 /*break*/, 9];
                case 7:
                    error_3 = _a.sent();
                    console.error('Order submission error:', error_3);
                    setErrors({
                        submit: error_3.message || (language === 'bg'
                            ? 'Грешка при изпращане на поръчката. Моля, опитайте отново.'
                            : 'Error submitting order. Please try again.')
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleSuccessClose = function () {
        setShowSuccessModal(false);
        onClose();
    };
    if (!isOpen)
        return null;
    return (_jsxs("div", { className: "checkout-modal-overlay", onClick: onClose, children: [_jsxs("div", { className: "checkout-modal", onClick: function (e) { return e.stopPropagation(); }, ref: modalRef, tabIndex: -1, children: [_jsxs("div", { className: "checkout-header", children: [_jsx("h2", { children: language === 'bg' ? 'Завършване на поръчка' : 'Complete Your Order' }), _jsx("button", { onClick: onClose, className: "checkout-close-btn", children: "\u00D7" })] }), _jsxs("div", { className: "checkout-content", children: [_jsxs("div", { className: "checkout-summary", children: [_jsx("h3", { children: language === 'bg' ? 'Обща сума:' : 'Total Amount:' }), _jsx("div", { className: "checkout-totals", children: _jsx("p", { className: "checkout-total", children: formatEUR(totalPriceEur) }) })] }), _jsxs("form", { onSubmit: handleSubmit, className: "checkout-form", children: [_jsxs("div", { className: "delivery-methods", children: [_jsx("h3", { children: language === 'bg' ? 'Изберете метод на доставка' : 'Choose Delivery Method' }), _jsxs("label", { className: "delivery-option ".concat(formData.deliveryMethod === 'address' ? 'selected' : ''), children: [_jsx("input", { type: "radio", name: "deliveryMethod", value: "address", checked: formData.deliveryMethod === 'address', onChange: handleChange }), _jsxs("div", { className: "delivery-option-content", children: [_jsx("div", { className: "delivery-option-title", children: language === 'bg' ? 'Доставка до адрес' : 'Delivery to an address' }), _jsx("div", { className: "delivery-option-description", children: language === 'bg'
                                                                    ? 'Безплатна доставка за град София'
                                                                    : 'Free delivery for Sofia' })] })] }), _jsxs("label", { className: "delivery-option ".concat(formData.deliveryMethod === 'office' ? 'selected' : ''), children: [_jsx("input", { type: "radio", name: "deliveryMethod", value: "office", checked: formData.deliveryMethod === 'office', onChange: handleChange }), _jsxs("div", { className: "delivery-option-content", children: [_jsxs("div", { className: "delivery-option-title", children: [language === 'bg' ? 'Доставка до офис или автомат на куриер' : 'Courier Office/Locker Delivery', _jsx("span", { className: "delivery-price", children: "(3,50 \u20AC)" })] }), _jsx("div", { className: "delivery-option-description", children: language === 'bg'
                                                                    ? 'Изберете офис или автомат на ЕКONT'
                                                                    : 'Select ECONT office or locker' })] })] })] }), _jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "name", children: [language === 'bg' ? 'Име и Фамилия' : 'Full Name', " ", _jsx("span", { className: "required", children: "*" })] }), _jsx("input", { type: "text", id: "name", name: "name", value: formData.name, onChange: handleChange, className: errors.name ? 'error' : '', placeholder: language === 'bg' ? 'Вашето име' : 'Your name' }), errors.name && _jsx("span", { className: "error-message", children: errors.name })] }), _jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "phone", children: [language === 'bg' ? 'Телефон' : 'Phone', " ", _jsx("span", { className: "required", children: "*" })] }), _jsx("input", { type: "tel", id: "phone", name: "phone", value: formData.phone, onChange: handleChange, className: errors.phone ? 'error' : '', placeholder: language === 'bg' ? '+359 ...' : '+359 ...' }), errors.phone && _jsx("span", { className: "error-message", children: errors.phone })] }), _jsxs("div", { className: "form-row", children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "email", children: ["Email ", _jsx("span", { className: "required", children: "*" })] }), _jsx("input", { type: "email", id: "email", name: "email", value: formData.email, onChange: handleChange, className: errors.email ? 'error' : '', placeholder: "example@email.com" }), errors.email && _jsx("span", { className: "error-message", children: errors.email })] }), formData.deliveryMethod === 'address' && (_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "city", children: [language === 'bg' ? 'Град' : 'City', " ", _jsx("span", { className: "required", children: "*" })] }), _jsx("input", { type: "text", id: "city", name: "city", value: formData.city, onChange: handleChange, className: errors.city ? 'error' : '', placeholder: language === 'bg' ? 'Град' : 'City' }), errors.city && _jsx("span", { className: "error-message", children: errors.city })] }))] }), formData.deliveryMethod === 'address' && (_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "address", children: [language === 'bg' ? 'Адрес' : 'Address', " ", _jsx("span", { className: "required", children: "*" })] }), _jsx("input", { type: "text", id: "address", name: "address", value: formData.address, onChange: handleChange, className: errors.address ? 'error' : '', placeholder: language === 'bg' ? 'Улица, номер' : 'Street, number' }), errors.address && _jsx("span", { className: "error-message", children: errors.address })] })), formData.deliveryMethod === 'office' && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "econtCity", children: [language === 'bg' ? 'Град' : 'City', " ", _jsx("span", { className: "required", children: "*" })] }), _jsxs("select", { id: "econtCity", value: selectedCityId, onChange: function (e) {
                                                            setSelectedCityId(e.target.value);
                                                            setFormData(function (prev) { return (__assign(__assign({}, prev), { speedyOffice: '' })); }); // Reset office when city changes
                                                        }, className: errors.speedyOffice ? 'error' : '', disabled: loadingCities, children: [_jsx("option", { value: "", children: loadingCities
                                                                    ? (language === 'bg' ? 'Зареждане...' : 'Loading...')
                                                                    : (language === 'bg' ? 'Изберете населено място' : 'Select location') }), !loadingCities && cities.length > 0 && (_jsx("option", { value: "", disabled: true, className: "city-separator", children: "\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500" })), cities.flatMap(function (city, index) {
                                                                var options = [
                                                                    _jsx("option", { value: city.id, children: city.name }, city.id)
                                                                ];
                                                                if (index === 9) {
                                                                    options.push(_jsx("option", { value: "", disabled: true, className: "city-separator", children: "\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500" }, "separator"));
                                                                }
                                                                return options;
                                                            })] })] }), selectedCityId && (_jsxs("div", { className: "form-group", children: [_jsxs("label", { htmlFor: "speedyOffice", children: [language === 'bg' ? 'Офис на Еконт' : 'Econt Office', " ", _jsx("span", { className: "required", children: "*" })] }), _jsxs("select", { id: "speedyOffice", name: "speedyOffice", value: formData.speedyOffice, onChange: handleChange, disabled: loadingOffices, className: errors.speedyOffice ? 'error' : '', children: [_jsx("option", { value: "", children: loadingOffices
                                                                    ? (language === 'bg' ? 'Зареждане офиси...' : 'Loading offices...')
                                                                    : (language === 'bg' ? 'Изберете офис' : 'Select office') }), offices.map(function (office) { return (_jsxs("option", { value: "".concat(office.name, " - ").concat(office.address.fullAddress), children: [office.name, " - ", office.address.fullAddress] }, office.id)); })] }), errors.speedyOffice && _jsx("span", { className: "error-message", children: errors.speedyOffice })] })), errors.econt && (_jsx("div", { className: "error-message", style: { marginTop: '8px' }, children: errors.econt }))] })), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: "notes", children: language === 'bg' ? 'Забележки' : 'Notes' }), _jsx("textarea", { id: "notes", name: "notes", value: formData.notes, onChange: handleChange, rows: 3, placeholder: language === 'bg' ? 'Допълнителна информация...' : 'Additional information...' })] }), errors.submit && (_jsx("div", { className: "error-message", style: { marginTop: '12px', textAlign: 'center' }, children: errors.submit })), _jsx("button", { type: "submit", className: "checkout-submit-btn", disabled: isSubmitting, children: isSubmitting
                                            ? (language === 'bg' ? 'Изпращане...' : 'Submitting...')
                                            : (language === 'bg' ? 'Потвърди поръчка' : 'Confirm Order') })] })] })] }), showSuccessModal && (_jsx("div", { className: "success-modal-overlay", onClick: handleSuccessClose, children: _jsxs("div", { className: "success-modal-content", onClick: function (e) { return e.stopPropagation(); }, children: [_jsx("div", { className: "success-icon", children: _jsxs("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "12", cy: "12", r: "10", stroke: "#2D7A2D", strokeWidth: "2", fill: "none" }), _jsx("path", { d: "M7 12L10.5 15.5L17 9", stroke: "#2D7A2D", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })] }) }), _jsx("h2", { children: language === 'bg' ? 'Получихме вашата поръчка' : 'We received your order' }), _jsx("p", { children: language === 'bg'
                                ? 'Благодарим Ви за поръчката! Ще получите потвърждение на имейл.'
                                : 'Thank you for your order! You will receive a confirmation email.' }), _jsx("button", { onClick: handleSuccessClose, className: "success-ok-btn", children: language === 'bg' ? 'Затвори' : 'OK' })] }) }))] }));
};
export default CheckoutModal;
